<template>
  <div style="line-height: 1.5">
    <p>
      <strong>1) តើខ្ញុំនឹងទទួលបានអ្វីក្នុងនាមជាអ្នកណែនាំ?</strong>
      <label>អ្នកនឹងទទួលបាន 2ដុលា្ល នៅពេលដែលមនុស្សដែលអ្នកបានណែនាំបង់ប្រាក់កម្ចីរបស់គេរួចរាល់អស់</label>
    </p>
    <p>
      <strong>2) តើលក្ខខណ្ឌអ្វីខ្លះដើម្បីក្លាយជាអ្នកណែនាំ?</strong>
      <label>
        ក្លាយជាអ្នកអតិថជនរបស់ Cash Hero។ បំពេញសំណុំបែបបទការណែនាំ។ អ្នកណែនាំគួរតែជាពលរដ្ឋកម្ពុជា ដែលមានអាយុ 18 ទៅ 50
        ឆ្នាំ រស់នៅទីក្រុងភ្នំពេញ, សៀមរាប ឬក្រុងព្រះសីហនុ និងមានប្រាក់ចំណូលប្រចាំខែមានស្ថេរភាព។
      </label>
    </p>
    <p>
      <strong>3) តើខ្ញុំទទួលបានប្រាក់ដោយរបៀបណា?</strong>
      <label>
        Cash Hero នឹងធ្វើការទូទាត់ផ្ទេរប្រាក់ទៅក្នុងគណនីធនាគាររបស់អ្នក។ អ្នកនឹងទទួលបានអ៊ីម៉ែលនៅពេលដែល
        មនុស្សដែលអ្នកបានណែនាំធ្វើការបង់ប្រាក់រួចរាល់។
      </label>
    </p>
  </div>
</template>

<script>
export default {
  name: 'ReferralKhmer'
}
</script>

<style scoped>

</style>
